export interface Page<T> {
  max_items: number;
  next_token?: string;
  asc?: boolean;
  content?: T[];
}

export const DEFAULT_PAGE: Page<never> = {
  max_items: 10,
  asc: true
};

export function addPageParams(url: string, page: Page<never>): string {
  let result = url.includes('?') ? `${url}&max_items=${page.max_items || 10}` : `${url}?max_items=${page.max_items || 10}`;

  if (page.asc) result = `${result}&asc=${page.asc}`;
  if (page.next_token) result = `${result}&next_token=${page.next_token}`;

  return result;
}
